import ReactGA from 'react-ga4';
import APP_CONSTANTS from '@/utils/constants/app.constants';

const GA_TRACKING_ID = import.meta.env.VITE_GA_TRACKING_ID;
const ENVIRONMENT = APP_CONSTANTS.ENVIRONNEMENT;

const checkTrackingID = (warn: boolean = false) => {
  if (!GA_TRACKING_ID) {
    if (warn) console.warn('GA_TRACKING_ID is not set');
    return false;
  }
  return true;
};

export const initGA = () => {
  if (checkTrackingID(true)) {
    ReactGA.initialize(GA_TRACKING_ID);
    // Set custom dimension for environment
    ReactGA.gtag('set', 'environment', ENVIRONMENT);
    // Log initialization
    console.log(`GA initialized for environment: ${ENVIRONMENT}`);
  }
};

export const trackPageView = (url: string) => {
  if (checkTrackingID())
    ReactGA.send({
      hitType: 'pageview',
      page: url,
    });
};

export const trackEvent = (
  category: string,
  action: string,
  label: string | null,
  value: number | null
) => {
  if (checkTrackingID())
    ReactGA.event({
      category: category,
      action: action,
      label: label ?? undefined,
      value: value ?? undefined,
    });
};
